import { Attributes, Misc, NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class CorporateActionEventSearchCriteria extends ValueObject {
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public rangeStartDate: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public rangeEndDate: Date | null = null;

    public rawEventType: string | null = null;

    public rawCorporateActionType: string | null = null;

    public rawUnderlyingSecurityCode: string | null = null;
}